import FemmesEntreprisesTransport from "./indicators/FemmesEntreprisesTransport";
import PartBudgetMoyenMobilite from "./indicators/PartBudgetMoyenMobilite";
import TauxCouvertureReseauTransportUrbain from "./indicators/TauxCouvertureReseauTransportUrbain";

const ChallengeTwo = {
    idSection: "challengeTwo",
    titleSection:
        "SUMP Trajectory Content.challenges.challenge2.challengeTitle",
    objectives: {
        objective1: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge2.objectives.objective1",
            indicators: {
                tauxCouvertureReseauTransportUrbain:
                    TauxCouvertureReseauTransportUrbain,
            },
        },
        objective2: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge2.objectives.objective2",
            indicators: {
                partBudgetMoyenMobilite: PartBudgetMoyenMobilite,
            },
        },
        objective3: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge2.objectives.objective3",
            indicators: {
                femmesEntreprisesTransport: FemmesEntreprisesTransport,
            },
        },
    },
};

export default ChallengeTwo;
